import React, { Suspense, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import {
  VehicleList,
  VehicleStats,
  NewVehicleSearch,
} from "../components/vehicle";
import VehicleGroupDetails from "../components/vehicle/VehicleGroupDetails";
import "../styles/vehicle.css";
import StatSkeleton from "../components/common/StatSkeleton";
import VehicleSearch from "../components/vehicle/VehicleSearch";

const Vehicles = (props) => {
  const { vehicleSearchToggle, setVehicleSearchToggle } = props;
  const [vehicleId, setVehicleId] = useState();
  const [selectedGroupsItems, setSelectedGroupsItems] = useState([]);
  const [refetchGroupsList, setRefetchGroupsList] = useState(false);
  const [open, setOpen] = useState(false);
  const [queryGroupName, setQueryGroupName] = useState("");
  const [extraFilters, setExtraFilters] = useState([]);

  const [selectedVehiclesSerials, setSelectedVehiclesSerials] = useState([]);
  const [selectedVehiclesList, setSelectedVehiclesList] = useState([]);

  const resetDataTableSelectionItems = () => {
    setSelectedVehiclesList([]); // Reset the data table selection
    setSelectedVehiclesSerials([]); // Reset the data table selection
  };

  const openQueryBuilder = (name) => {
    if (name) {
      setQueryGroupName(name);
    }
    setOpen(true);
  };

  const onSuccess = () => {
    setTimeout(() => {
      if (doRefetchGroupsList) doRefetchGroupsList();
    }, 1000);
  };

  const handleClose = () => {
    setOpen(false);
    setQueryGroupName("");
    onSuccess();
  };

  const vehicleSearchprops = {
    vehicleId,
    setVehicleId,
    openQueryBuilder,
    extraFilters,
    setExtraFilters,
    resetDataTableSelectionItems,
  };

  const doRefetchGroupsList = () => {
    setRefetchGroupsList(true);
  };

  useEffect(() => {
    if (refetchGroupsList) {
      setTimeout(() => {
        setRefetchGroupsList(false);
      }, 1000);
    }
  }, [refetchGroupsList]);

  const vehicleListProps = {
    vehicleId,
    groupItemsDataArray: selectedGroupsItems,
    selectedGroupsItems,
    doRefetchGroupsList,
    refetchGroupsList,
    extraFilters,
    setExtraFilters,
    selectedVehiclesSerials,
    setSelectedVehiclesSerials,
    selectedVehiclesList,
    setSelectedVehiclesList,
  };

  const vehicleGroupListProps = {
    selectedGroupsItems,
    setSelectedGroupsItems,
    doRefetchGroupsList,
    refetchGroupsList,
    openQueryBuilder,
    extraFilters,
    setExtraFilters,
  };

  const queryBuilderProps = {
    openQueryBuilder,
    onClose: handleClose,
    onSuccess: onSuccess,
    open,
    doRefetchGroupsList,
    refetchGroupsList,
    queryGroupName,
    setQueryGroupName,
  };
  useEffect(() => {
    setExtraFilters([]);
  }, [vehicleSearchToggle]);

  return (
    <div className="fragmentContainer">
      <Grid container spacing={2}>
        <Suspense
          fallback={
            <>
              <StatSkeleton tiles={2} width={3} />
              <StatSkeleton width={4} repeat={2} />
              <StatSkeleton width={2} />
            </>
          }
        >
          <VehicleStats />
        </Suspense>
        {!vehicleSearchToggle ? (
          <>
            <VehicleSearch {...vehicleGroupListProps} />
            <Grid item xs={12} md={9}>
              <VehicleList {...vehicleListProps} />
            </Grid>
          </>
        ) : (
          <>
            <NewVehicleSearch {...vehicleGroupListProps} />
            <Grid item xs={12} md={100}>
              <VehicleList {...vehicleListProps} />
            </Grid>
          </>
        )}
      </Grid>
      <VehicleGroupDetails {...queryBuilderProps} />
    </div>
  );
};

export default Vehicles;
